<template>
    <div class="messages__content">
        <div
            v-for="group in groupedMessages()"
            class="messages__day"
            :key="group.date"
        >
            <div class="messages__separator">
                <span>{{ group.date }}</span>
            </div>
            <div
                v-for="message in group.messages"
                :class="{
                    'message__wrapper': true,
                    'message__wrapper--me': message.is_sender,
                }"
                :key="message.id"
            >
                <div class="message">
                    <div class="message__header">
                        <div class="message__sender">
                            {{ message.sender.you === false ? message.sender.name ? message.sender.name : "System" : user }}
                        </div>
                        <div class="message__date">{{ message.sentAt.split(' ')[1] }}</div>
                    </div>
                    <div
                        class="message__content"
                        v-html="message.content"
                    ></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MessagesContainer",
    props: ["activeCase", "currentReport", "user"],
    methods: {
        groupedMessages() {
            return this.activeCase.reduce((acc, curr) => {
                const date = curr.sentAt.split(" ")[0];

                if (!acc.find((el) => el.date === date))
                    acc.push({ date: date, messages: [] });

                acc.find((el) => el.date === date).messages.push(curr);

                return acc;
            }, []);
        },
    },
};
</script>

<style lang="scss">
.message {
    $this: &;
    border-radius: 20px;
    padding: 12px 20px;
    max-width: calc(100% - 160px);

    &__wrapper {
        display: flex;
        margin: 10px;
        &:not(.message__wrapper--me) {
            #{$this} {
                background: rgba(54, 186, 202, 0.1);
                color: black;
            }
            #{$this}__wrapper {
                justify-content: flex-start;
            }
        }
        &--me {
            display: flex;
            justify-content: flex-end;
            #{$this} {
                background: rgba(0, 0, 0, 0.03);
                color: black;
            }
        }
    }

    &__header {
        display: flex;
        align-items: flex-end;
    }

    &__sender {
        font-weight: 600;
        margin-right: 10px;
        color: #158491;
    }
    &__date {
        color: #b2b2b2;
        font-size: 12px;
        line-height: 2;
    }
}
</style>
